require('../../modules/es6.array.iterator');
module.exports = require('../../modules/_core').Array.values;



//////////////////
// WEBPACK FOOTER
// ../~/core-js/fn/array/iterator.js
// module id = 943
// module chunks = 0